// extracted by mini-css-extract-plugin
module.exports = {"EducationOrgData":"_1ySeCXgV","educationOrgDataInfoWrapper":"_4rQciq9R","educationOrgDataInfoWrapperShort":"_14LcfpfR","educationOrgDataAvatarWrapper":"_29PG2V0D","educationOrgDataAvatarLargeWrapper":"_2zg5Ox6y","educationOrgDataAvatarSmallWrapper":"_1rTlA3av","educationOrgDataTitle":"_1GmUYcH9","educationOrgDataTitleSmall":"_2xYa8B_j","educationOrgName":"_2r7S2lD0","educationOrgDataSubtitle":"_3qGLFzt2","educationOrgDataSubtitleBold":"_2CIxQzfI"};
    if(module.hot) {
      // 1746735886897
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  